module.exports = __webpack_public_path__ + "static/media/nodejs-icon.68eecf31.png";